import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";

export const getCurrencyByUserAndCompany = async (companyId: number) => {
  const { data } = await axiosInstance.get("/shares/user-company", {
    params: { companyId },
    withCredentials: true,
  });
  return data;
};

export const useGetCurrencyByUserAndCompany = (
  companyId?: number | null,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ["sharesByUserAndCompany", companyId],
    queryFn: () => getCurrencyByUserAndCompany(companyId as number),
    enabled: !!companyId && (options?.enabled ?? true),
    staleTime: 60_000,
  });
};
